import { LOCALE_ID, NgModule, APP_INITIALIZER } from '@angular/core';
import {PathLocationStrategy, LocationStrategy, CommonModule, registerLocaleData} from '@angular/common';
import localeIt from '@angular/common/locales/it';

// Formati italiani per i pipe number/date/currency: importi come "€ 85,00"
// (scheda _1 pag. 8: virgola decimale, punto per le migliaia)
registerLocaleData(localeIt);
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { from, Observable } from 'rxjs';
import {DialogModule} from "primeng/dialog";
import {ButtonModule} from "primeng/button";
import {GtmModule} from "./gtm_module";
import {UtmService} from "./_services/utm_service";
import {environment} from "../environments/environment";
/**
 * Le traduzioni entrano nella build invece di essere lette da assets (22/10/2026).
 *
 * Prima si scaricava `assets/i18n/it.json`, sempre con lo stesso nome: dopo un
 * deploy il browser teneva la copia vecchia e in produzione comparivano le
 * chiavi nude (es. `chat_nota_chiusa`) accanto alla grafica nuova. Con
 * l'import dinamico ogni lingua diventa un file con il codice del contenuto
 * nel nome, come i JS: cambia solo quando cambia il testo.
 *
 * I file da modificare restano quelli in `src/assets/i18n/`.
 */
export class TraduzioniLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
        return from(import(`../assets/i18n/${lang}.json`).then(m => m.default ?? m));
    }
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TraduzioniLoader
            }
        }),
        DialogModule,
        ButtonModule,
        CommonModule,
        GtmModule.forRoot({ id: environment.gtag })
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'it' },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        {
            // Cattura i parametri UTM dall'URL di atterraggio prima che il router intervenga
            provide: APP_INITIALIZER,
            multi: true,
            useFactory: (utm: UtmService) => () => utm.captureFromUrl(),
            deps: [UtmService]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true // Importante per registrare più interceptor
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
